import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <main>
      <div className="header">
        <span className="footer__span">
          Copyright © 2023{" "}
          <a href="https://github.com/Apwa00000411">Amphawa Thadthai</a> All
          Rights Reserved
        </span>
        <span className="footer__span">
          feel free to connect <a>amphawa0@gmail.com</a>
        </span>
      </div>
    </main>
  );
};

export default Footer;
